import Color from '../Color.mjs'
import superMeta from '../_ARCH/metaArchNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.LIGHT_YELLOW,
    alias: '组织模型',
    archName: '组织地图',
    archUrl: '/ProjectOrgMap',
    detailUrl: '/OaDetail',
    detailIdProp: 'oaId',
    listUrl: '/OaList',
    mapProp: 'oaMap',
    moduleType: 'OM',
    name: '组织结构',
    type: 'OA',
}
